export enum ThemeLandingType {
  YAZ_TATILI = 'yaz_tatili',
  KIS_TATILI = 'kis_tatili',
  SURDURULEBILIRLIK_TEMASI = 'surdurulebilirlik_temasi',
  YURT_DISI_SELECT_OTELLER = 'yurt_disi_select_oteller',
}
